import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
interface ResultsDesktopAudioTestModal {
  closeButton: ICSSInJSStyle;
  audioDesktopDialogContainer: ICSSInJSStyle;
  audioDesktopDialogContent: ICSSInJSStyle;
}

export const useResultsDesktopAudioTestModal: () => ResultsDesktopAudioTestModal =
  () => {
    const { main } = useFluentColorScheme();

    return {
      closeButton: {
        padding: pxToRem(28),
      },
      audioDesktopDialogContainer: {
        width: "787px",
        height: "590px",
        padding: "0px",
        backgroundColor: main.background,
      },
      audioDesktopDialogContent: {
        width: "100%",
        height: "100%",
        backgroundColor: main.background,
      },
    };
  };
